import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#ff8a00',
    },
    secondary: {
      main: '#e52e71',
    },
    background: {
      default: 'rgba(255, 255, 255, 0.1)',
      paper: 'rgba(255, 255, 255, 0.1)',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    }
  },
  gradients: {
    primary: 'linear-gradient(135deg, #ff8a00, #e52e71)',
    secondary: 'linear-gradient(135deg, #3a86ff, #ff006e)',
    tertiary: 'linear-gradient(135deg, #ff5f6d, #ffc371)',
    whiteButton: 'white',
  },
  typography: {
    h5: {
      fontWeight: 600,
      color: '#ffffff',
    },
    body2: {
      color: 'rgba(255, 255, 255, 0.7)',
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '4px',
          padding: '10px 20px',
        },
      },
    },
  },
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ff8a00',
    },
    secondary: {
      main: '#e52e71',
    },
    background: {
      default: 'rgba(0, 0, 0, 0.1)',
      paper: 'rgba(0, 0, 0, 0.1)',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    }
  },
  gradients: {
    primary: 'linear-gradient(135deg, #ff8a00, #e52e71)',
    secondary: 'linear-gradient(135deg, #3a86ff, #ff006e)',
    tertiary: 'linear-gradient(135deg, #ff5f6d, #ffc371)',
    whiteButton: 'white',
  },
  typography: {
    h5: {
      fontWeight: 600,
      color: '#ffffff',
    },
    body2: {
      color: 'rgba(255, 255, 255, 0.7)',
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '4px',
          padding: '10px 20px',
        },
      },
    },
  },
});

export { lightTheme, darkTheme };